import React from "react";

const Svg = ({ stroke = "#828282" }: { stroke?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clipPath="url(#clip0_366_1932)">
        <path
          d="M8.20117 13.9922C11.5149 13.9922 14.2012 11.3059 14.2012 7.99219C14.2012 4.67848 11.5149 1.99219 8.20117 1.99219C4.88746 1.99219 2.20117 4.67848 2.20117 7.99219C2.20117 11.3059 4.88746 13.9922 8.20117 13.9922Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.20117 5.32544V7.99211"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.20117 10.6589H8.20784"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_366_1932">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.201172 -0.0078125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Svg;
